import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetDashboardIntegrationsRequest,
    type OpenApiGetDashboardIntegrationsResponseSuccess,
} from '#shared/api/schema';

const apiDashboardIntegrations = createApi({
    name: 'entities/dashboard/api/integrations',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            get: builder.query<OpenApiGetDashboardIntegrationsResponseSuccess, OpenApiGetDashboardIntegrationsRequest>({
                query: () => {
                    return {
                        url: '/dashboard/integrations',
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const useGetDashboardIntegrations = apiDashboardIntegrations.useGetQuery;
